import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListView } from '../core/ListViewProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { PacienteColumns } from './columns/_columns'
import { PacienteList } from '../core/_models'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

export const PacientesTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { selected } = useListView()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()
  const columns = useMemo(() => PacienteColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhum paciente encontrado'
      description={`Revise o nome, a ${t('empresa.label.lowercase')} ou a situação.`}
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum paciente cadastrado'
      description='Use “Adicionar” para localizar e cadastrar o primeiro paciente.'
    />
  )

  return (
    <CustomTable<PacienteList>
      id='kt_table_pacientes'
      ariaLabel='Pacientes'
      itemLabel={{ singular: 'paciente', plural: 'pacientes' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      isRowSelected={(row) => selected.includes(row.id)}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
